import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { SignUpForm } from './SignUpForm';
import { withNamespaces } from 'react-i18next';

const styles = (theme) => ({
  submitWrapper: {
    margin: '0 auto',
    width: '200px',
  },
});

const SignUpTabComponent = ({ classes, provider, t, ...props }) => (
  <div className={classes.tabContainer}>
    <h1 className={classes.title}>{t('sign_up_its_free', 'Sign up. It’s free.')}</h1>
    <h4 className={classes.subtext}>
      {t('credit_cards_not_required', 'Credit cards never required')}!
    </h4>
    <SignUpForm
      submitLabel={t('sign_up_free', 'Sign up free')}
      openDialog={props.openDialog}
      {...props}
      classes={{
        footer: classes.footer,
        footer__terms: classes.footer__terms,
        footer__otherAccountPage: classes.footer__otherAccountPage,
        submitWrapper: classes.submitWrapper,
      }}
    />
  </div>
);
SignUpTabComponent.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  provider: PropTypes.string,
  openDialog: PropTypes.func.isRequired,
};
SignUpTabComponent.defaultProps = {
  provider: null,
};

export const SignUpTab = withStyles(styles)(withNamespaces()(SignUpTabComponent));
